import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('atolyekirpi_token');
        const savedUser = localStorage.getItem('atolyekirpi_user');
        if (token && savedUser) {
            setUser(JSON.parse(savedUser));
            authAPI.me().then(res => {
                setUser(res.data.user);
                localStorage.setItem('atolyekirpi_user', JSON.stringify(res.data.user));
            }).catch((err) => {
                if (err.response?.data?.mustChangePassword) return;
                localStorage.removeItem('atolyekirpi_token');
                localStorage.removeItem('atolyekirpi_user');
                setUser(null);
            });
        }
        setLoading(false);
    }, []);

    const login = async (username, password) => {
        const res = await authAPI.login({ username, password });
        localStorage.setItem('atolyekirpi_token', res.data.token);
        if (res.data.mustChangePassword) {
            // Şifre değişene kadar oturum açılmaz; token sadece change-password için saklanır
            localStorage.removeItem('atolyekirpi_user');
            sessionStorage.setItem('atolyekirpi_mcp', '1');
            return res.data;
        }
        localStorage.setItem('atolyekirpi_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data;
    };

    const changePassword = async (currentPassword, newPassword) => {
        const res = await authAPI.changePassword({ currentPassword, newPassword });
        sessionStorage.removeItem('atolyekirpi_mcp');
        localStorage.setItem('atolyekirpi_token', res.data.token);
        localStorage.setItem('atolyekirpi_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem('atolyekirpi_token');
        localStorage.removeItem('atolyekirpi_user');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, changePassword, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
